import '../scss/show-news.scss';

import HorizontalMenuBar from 'application/src/js/util/horizontal-menu-bar.js';
import NewsImageSlider from './show-news/news-image-slider.js';
import ToggleShowMore from './show-news/toggle-show-more.js';
import NewsAudioPlayer from './show-news/news-audio-player.js';
import {
  FlyoutMenu,
  ModalWindow
} from 'application/src/js/util';

window.addEventListener('DOMContentLoaded', _ => {
  new HorizontalMenuBar({
    element: document.querySelector('.view-news .horizontal-menu-bar')
  });

  [...document.querySelectorAll('.view-news .toggle-show-more')].map(element => new ToggleShowMore(element));

  new NewsAudioPlayer();
  new NewsImageSlider();

  if (document.querySelector('.news-lang-select .flyout-menu')) {
    new FlyoutMenu({
      element: document.querySelector('.news-lang-select .flyout-menu')
    });
  }

  if (document.querySelector('#login-modal')) {
    const loginModal = new ModalWindow(document.querySelector('#login-modal'), {
      backgroundIsCloseTrigger: true,
      openButton: document.querySelectorAll('.button-open-login-modal')
    });

    loginModal.subscribe('open', _ => {
      loginModal.element.querySelector('input').focus();
    })
  }

  new WrapTables();
});

class WrapTables {
  constructor(args) {
    this.container = document.querySelector('.view-news .news-text');
    this.tables = [...this.container.querySelectorAll('table')];

    this.wrap();
  }

  wrap() {
    this.tables.map(tableElement => {
      const wrapperElement = document.createElement('div');
      wrapperElement.classList.add('overflow-scroll-x');
      tableElement.insertAdjacentElement('beforebegin', wrapperElement);
      wrapperElement.insertAdjacentElement('beforeend', tableElement);
    });
  }
}